
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/[eventSlug]",
      function () {
        return require("private-next-pages/community/[eventSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/[eventSlug]"])
      });
    }
  